import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AppDetail from '../views/AdDetailView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),

  // /d/{appId}でアクセスされた場合は、AppDetailView.vueを表示する。

  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('../views/AdDetailView.vue')
    },
    {
      path: '/d/:appId',
      name: 'app-detail',
      component: AppDetail
    }
  ]
})

export default router
